import { useEffect, useMemo, useState } from 'react';
import { applyResolvedUrlsToDoc, type TiptapDoc } from '@odo/shared-ui';
import {
    resolveDocImagesInBackground,
    type ResolvedImageUrls
} from '../../../utils/docImageResolution';

const IMAGE_SOURCE = 'VirtualAppointmentsOverview.resolveDescriptionImages';

// Stored docs carry expiring image URLs; swaps in fresh signed ones once they resolve.
export function useResolvedDescriptionDoc(
    patientId: string,
    doc: TiptapDoc | null
): TiptapDoc | null {
    const [urls, setUrls] = useState<ResolvedImageUrls>({});

    useEffect(() => {
        if (!doc) return undefined;
        return resolveDocImagesInBackground(patientId, [doc], IMAGE_SOURCE, (resolved) =>
            setUrls((prev) => ({ ...prev, ...resolved }))
        );
    }, [patientId, doc]);

    return useMemo(() => (doc ? applyResolvedUrlsToDoc(doc, urls) : null), [doc, urls]);
}
